import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const token = localStorage.getItem('storepointe_token');
    const storedUser = localStorage.getItem('storepointe_user');
    if (token && storedUser) {
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
      // Verify token is still valid
      authAPI.getMe()
        .then((res) => {
          setUser(res.data);
          localStorage.setItem('storepointe_user', JSON.stringify(res.data));
        })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  const login = useCallback(async (email, password) => {
    const res = await authAPI.login({ email, password });
    if (!['super_admin', 'system_admin', 'system_support'].includes(res.data.user.role)) {
      throw new Error('You do not have permission to access this dashboard.');
    }
    localStorage.setItem('storepointe_token', res.data.token);
    localStorage.setItem('storepointe_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    setIsAuthenticated(true);
    return res.data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await authAPI.logout(); } catch (e) {}
    localStorage.removeItem('storepointe_token');
    localStorage.removeItem('storepointe_user');
    setUser(null);
    setIsAuthenticated(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
